// extracted by css-extract-rspack-plugin
export default {"root":"root-kiH0uM","invert":"invert-r0wfBK"};